import { alpha } from "@mui/material";
function createDarkPalette(tidalColors) {
  return {
    accent: {
      contrastText: tidalColors.seafoamTeal[50],
      dark: tidalColors.seafoamTeal[700],
      light: tidalColors.seafoamTeal[400],
      main: tidalColors.seafoamTeal[500]
    },
    accentNeutral: {
      contrastText: tidalColors.seafoamTeal[50],
      dark: tidalColors.seafoamTeal[400],
      light: tidalColors.seafoamTeal[200],
      main: tidalColors.seafoamTeal[300]
    },
    accentSoft: {
      contrastText: "#FFF",
      dark: tidalColors.seafoamTeal[200],
      light: tidalColors.seafoamTeal[50],
      main: tidalColors.seafoamTeal[100]
    },
    // ---------------------------------------------------------------------
    // Others
    // ---------------------------------------------------------------------
    action: {
      activatedOpacity: 0.56,
      active: alpha(tidalColors.slateBlueGray[900], 0.56),
      disabled: alpha(tidalColors.slateBlueGray[900], 0.38),
      // TODO: why is at 12%? shouldn't be at 38%?
      disabledBackground: alpha(tidalColors.slateBlueGray[900], 0.12),
      disabledOpacity: 0.38,
      focus: alpha(tidalColors.slateBlueGray[900], 0.12),
      focusOpacity: 0.12,
      hover: alpha(tidalColors.slateBlueGray[900], 0.08),
      hoverOpacity: 0.08,
      selected: alpha(tidalColors.slateBlueGray[900], 0.16),
      selectedOpacity: 0.16
    },
    background: {
      default: tidalColors.cloudGray[200],
      default2: tidalColors.cloudGray[100],
      default3: tidalColors.cloudGray[50],
      paper: tidalColors.cloudGray[300]
    },
    divider: tidalColors.slateBlueGray[200],
    error: {
      contrastText: tidalColors.lobsterRed[50],
      dark: tidalColors.lobsterRed[600],
      light: tidalColors.lobsterRed[400],
      main: tidalColors.lobsterRed[500]
    },
    // ---------------------------------------------------------------------
    // Neutral Semantic
    // ---------------------------------------------------------------------
    errorNeutral: {
      contrastText: "#FFFFFF",
      dark: tidalColors.lobsterRed[400],
      light: tidalColors.lobsterRed[200],
      main: tidalColors.lobsterRed[300]
    },
    // ---------------------------------------------------------------------
    // Medium Semantic
    // ---------------------------------------------------------------------
    errorSoft: {
      contrastText: "#FFF",
      dark: tidalColors.lobsterRed[200],
      light: tidalColors.lobsterRed[50],
      main: tidalColors.lobsterRed[100]
    },
    grey: {
      50: "#212121",
      100: "#424242",
      200: "#616161",
      300: "#757575",
      400: "#9E9E9E",
      500: "#BDBDBD",
      600: "#E0E0E0",
      700: "#EEEEEE",
      800: "#F5F5F5",
      900: "#FAFAFA",
      A100: "#303030",
      A200: "#616161",
      A400: "#AAAAAA",
      A700: "#D5D5D5"
    },
    info: {
      contrastText: tidalColors.skyBlue[50],
      dark: tidalColors.skyBlue[700],
      light: tidalColors.skyBlue[400],
      main: tidalColors.skyBlue[500]
    },
    infoNeutral: {
      contrastText: "#FFF",
      dark: tidalColors.skyBlue[400],
      light: tidalColors.skyBlue[200],
      main: tidalColors.skyBlue[300]
    },
    infoSoft: {
      contrastText: "#FFF",
      dark: tidalColors.skyBlue[200],
      light: tidalColors.skyBlue[50],
      main: tidalColors.skyBlue[100]
    },
    // ---------------------------------------------------------------------
    // Default Semantic (all colors except seafoam are MUI default)
    // ---------------------------------------------------------------------
    primary: {
      contrastText: tidalColors.cloudGray[100],
      dark: tidalColors.oceanBlue[700],
      light: tidalColors.oceanBlue[500],
      main: tidalColors.oceanBlue[600]
    },
    secondary: {
      contrastText: tidalColors.oceanBlue[900],
      dark: tidalColors.oceanBlue[300],
      light: tidalColors.oceanBlue[100],
      main: tidalColors.oceanBlue[200]
    },
    success: {
      contrastText: tidalColors.jadeGreen[50],
      dark: tidalColors.jadeGreen[700],
      light: tidalColors.jadeGreen[400],
      main: tidalColors.jadeGreen[500]
    },
    successNeutral: {
      contrastText: tidalColors.jadeGreen[50],
      dark: tidalColors.jadeGreen[400],
      light: tidalColors.jadeGreen[200],
      main: tidalColors.jadeGreen[300]
    },
    successSoft: {
      contrastText: "#FFF",
      dark: tidalColors.jadeGreen[200],
      light: tidalColors.jadeGreen[50],
      main: tidalColors.jadeGreen[100]
    },
    text: {
      contrastText: tidalColors.slateBlueGray[900],
      disabled: alpha(tidalColors.slateBlueGray[900], 0.55),
      primary: alpha(tidalColors.slateBlueGray[900], 0.95),
      secondary: alpha(tidalColors.slateBlueGray[900], 0.7)
    },
    tidalColors,
    warning: {
      contrastText: tidalColors.sunnyYellow[50],
      dark: tidalColors.sunnyYellow[800],
      light: tidalColors.sunnyYellow[400],
      main: tidalColors.sunnyYellow[500]
    },
    warningNeutral: {
      contrastText: tidalColors.sunnyYellow[50],
      dark: tidalColors.sunnyYellow[400],
      light: tidalColors.sunnyYellow[200],
      main: tidalColors.sunnyYellow[300]
    },
    warningSoft: {
      contrastText: "#FFF",
      dark: tidalColors.sunnyYellow[200],
      light: tidalColors.sunnyYellow[50],
      main: tidalColors.sunnyYellow[100]
    },
    workwaveBlue: "#002D5C"
  };
}
export {
  createDarkPalette
};
//# sourceMappingURL=createDarkPalette.js.map
